var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowLeftWithTailinline = function SvgArrowLeftWithTailinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.057 1.057a1.333 1.333 0 1 1 1.886 1.886L5.219 8.667h20.78a1.333 1.333 0 1 1 0 2.666H5.22l5.724 5.724a1.333 1.333 0 1 1-1.886 1.886l-8-8a1.328 1.328 0 0 1-.3-1.427c.065-.167.165-.324.3-.459l8-8Z",
    fill: "#040404"
  })));
};

export default SvgArrowLeftWithTailinline;